import api from './api';

export type SchoolTrackKey = 'short' | 'long';

export interface SchoolSlide {
  id: number;
  track: SchoolTrackKey;
  title: string;
  description?: string | null;
  video_url?: string | null;
  thumbnail_url?: string | null;
  sort_order: number;
  is_active: boolean;
  course_id?: number | null;
  created_by_id: number;
  created_at?: string | null;
  updated_at?: string | null;
}

export interface SchoolSlidePayload extends Partial<SchoolSlide> {
  videoFile?: File | null;
  thumbnailFile?: File | null;
}

export const schoolSlideService = {
  listPublic: async (track?: SchoolTrackKey) => {
    const params: any = {};
    if (track) params.track = track;
    const response = await api.get<{ slides: SchoolSlide[] }>('/school-slides', { params });
    return response.data.slides;
  },

  listAdmin: async (track?: SchoolTrackKey) => {
    const params: any = {};
    if (track) params.track = track;
    const response = await api.get<{ slides: SchoolSlide[] }>('/school-slides/admin', { params });
    return response.data.slides;
  },

  create: async (payload: SchoolSlidePayload) => {
    const formData = new FormData();
    if (payload.track) formData.append('track', payload.track);
    if (payload.title) formData.append('title', payload.title);
    if (payload.description !== undefined) formData.append('description', payload.description || '');
    if (payload.sort_order !== undefined) formData.append('sort_order', String(payload.sort_order));
    if (payload.is_active !== undefined) formData.append('is_active', payload.is_active ? 'true' : 'false');
    if (payload.course_id !== undefined && payload.course_id !== null) {
      formData.append('course_id', String(payload.course_id));
    }
    if (payload.videoFile) {
      formData.append('video', payload.videoFile);
    }
    if (payload.thumbnailFile) {
      formData.append('thumbnail', payload.thumbnailFile);
    }

    const response = await api.post<{ message: string; slide: SchoolSlide }>(
      '/school-slides/admin',
      formData,
      {
        headers: { 'Content-Type': 'multipart/form-data' },
      }
    );
    return response.data.slide;
  },

  update: async (id: number, payload: SchoolSlidePayload) => {
    const formData = new FormData();
    if (payload.track) formData.append('track', payload.track);
    if (payload.title !== undefined) formData.append('title', payload.title || '');
    if (payload.description !== undefined) formData.append('description', payload.description || '');
    if (payload.sort_order !== undefined) formData.append('sort_order', String(payload.sort_order));
    if (payload.is_active !== undefined) formData.append('is_active', payload.is_active ? 'true' : 'false');
    if (payload.course_id !== undefined) {
      formData.append('course_id', payload.course_id == null ? '' : String(payload.course_id));
    }
    if (payload.videoFile) {
      formData.append('video', payload.videoFile);
    }
    if (payload.thumbnailFile) {
      formData.append('thumbnail', payload.thumbnailFile);
    }

    const response = await api.put<{ message: string; slide: SchoolSlide }>(
      `/school-slides/admin/${id}`,
      formData,
      {
        headers: { 'Content-Type': 'multipart/form-data' },
      }
    );
    return response.data.slide;
  },

  remove: async (id: number) => {
    const response = await api.delete<{ message: string }>(`/school-slides/admin/${id}`);
    return response.data;
  },

  getTrackCourse: async (track: SchoolTrackKey) => {
    const response = await api.get<{ course_id: number | null }>('/school-slides/track-course', {
      params: { track },
    });
    return response.data.course_id;
  },
};


